.wrap {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--text-sm);
  line-height: var(--text-sm-line);
  color: var(--color-text-primary);
}

.caption {
  text-align: start;
  padding-block: var(--space-2);
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  caption-side: top;
}

.th {
  text-align: start;
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  padding: var(--space-2) var(--cell-padding-x);
  border-bottom: var(--border-width-thin) solid var(--color-border-strong);
  white-space: nowrap;
  vertical-align: bottom;
}

.td {
  padding: var(--cell-padding-y) var(--cell-padding-x);
  border-bottom: var(--border-width-thin) solid var(--color-border-default);
  vertical-align: top;
}

.compact .td {
  padding-block: var(--space-1);
}

.tr:last-child .td {
  border-bottom: 0;
}

.end {
  text-align: end;
}

.numeric {
  font-variant-numeric: tabular-nums;
}

.sortButton {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  min-height: 24px;
  margin: calc(var(--space-1) * -1);
  padding: var(--space-1);
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.sortButton:hover {
  background: var(--color-surface-hover);
}

.sortButton:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-border-focus);
  outline-offset: var(--focus-ring-offset);
}

.sortActive {
  color: var(--color-text-primary);
}

.sortGlyph {
  color: var(--color-text-tertiary);
  transition: transform var(--duration-fast) var(--easing-standard);
}

.sortActive .sortGlyph {
  color: var(--color-text-primary);
}

.sortAsc {
  transform: rotate(180deg);
}

.note {
  margin-top: var(--space-2);
  font-size: var(--text-xs);
  color: var(--color-text-tertiary);
}

/* Below --bp-md each row stacks into a labelled block. The header row is
 * hidden visually only; the `data-label` carries the column into each cell. */
@media (width < 768px) {
  .table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
  }

  .tr {
    display: block;
    padding-block: var(--space-2);
    border-bottom: var(--border-width-thin) solid var(--color-border-default);
  }

  .td {
    display: grid;
    grid-template-columns: minmax(6rem, 35%) 1fr;
    gap: var(--space-3);
    padding: var(--space-1) 0;
    border: 0;
    text-align: start;
  }

  .td::before {
    content: attr(data-label);
    color: var(--color-text-tertiary);
    font-size: var(--text-xs);
    line-height: var(--text-sm-line);
  }
}
